<template>
    <div class="skill-popup">
        <div class="skill-popup-inner">
            <div style="display: block; height: 20px;">
                <button @click="TogglePopup()" style="display: block; float: right; top: 5px;">
                    X
                </button>
            </div>
            <h1>Você completou seu perfil!</h1>
            <img src="../../assets/gifs/sucesso.gif" alt="gif-sucesso" width="200px" height="200px" />
            <p>Agora seu próximo passo é participar de um desafio!</p>
            <v-col cols="12" align-self="center">
                <v-hover v-slot:default="{ hover }">
                    <v-btn depressed block rounded href="https://ikone.global/challenges/in-progress"
                        :color="!!hover ? 'red darken-4' : 'primary'" style="color: white">Acessar desafios
                    </v-btn>
                </v-hover>
            </v-col>
        </div>
    </div>
</template>

<script>
export default{
    props: ['TogglePopup']
}
</script>

<style scoped lang="scss">
.skill-popup {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 999;
    background-color: rgba(0, 0, 0, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;
}

.skill-popup-inner {
    background: #fff;
    padding: 32px;
}

.skill-popup-inner h1 {
    color: #000;
    font-size: 18px;
    text-align: center;
}

.skill-popup-inner p {
    font-size: 14px;
    opacity: 0.7;
    text-align: center;
    width: 325px;
}
.skill-popup-inner img {
    display: block;
    margin: 0 auto;
}
</style>